import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";

export const ButtonComponent = ({
  title = "",
  styleObj = {},
  onClickHandler,
  ...props
}) => {
  return (
    <button
      onClick={() => onClickHandler()}
      className="comman-btn"
      style={styleObj}
      {...props}
    >
      <i className={props.icon} /> {title}
    </button>
  );
};

export const SearchBar = (props) => {
  const [searchText, setSearchText] = useState("");

  const searchHandler = ({ currentTarget }) => {
    setSearchText(currentTarget.value);
  };

  useEffect(() => {
    setSearchText(props.searchText);
  }, [props.searchText])

  const emptySearchHandler = () => {
    props.searchHandler("");
    setSearchText("");
  };

  const searchClickHandler = () => {
    props.searchHandler(searchText);
  };

  const onPressEnter = (e) => {
    if (e.keyCode === 13) {
      props.searchHandler(searchText);
    }
  }
  return (
    <div className="searchBox">
      <div className="form-box">
        <input type="text" placeholder="Search.." className="form-control" name="search" value={searchText} onChange={searchHandler} autoComplete="off" onKeyUp={onPressEnter} />
        <button className="btn search-table" type="button" onClick={searchClickHandler}>
          <i className="fa fa-search"></i>
        </button>
        <button className="btn close search-table" type="button" onClick={emptySearchHandler}>
          <i className="fa fa-times"></i>
        </button>
      </div>
    </div>
  );
};

export const TabsComponent = ({ type, tabsOptions, tabsHandler, selectedTab, userData }) => {

  return (
    <div className="tabSectn">
      <ul>
        {tabsOptions.map((tab, idx) => (
          <li
            key={idx}
            className={userData ? userData[tab.tab] === 1 ? tab.id === selectedTab.id ? "active " : "" : "tab-disabled" : tab.id === selectedTab.id ? "active " : ""}
            onClick={() => tabsHandler(tab)}
          >
            <i className={tab.icon}></i>
            {type == 'suggestions' ? tab.suggTitle : tab.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export const SideBar = ({
  selectedTab,
  selectedFilter,
  addReportHandler,
  onFiltersHander,
  getSideBarArcheiveData,
  reportsData,
  archieveDataObj
}) => {
  const [archieveData, setArchieveData] = useState(archieveDataObj)

  const archriveChangeHandler = (is_archive) => {
    let archieveDataTemp = cloneDeep(archieveData);
    archieveDataTemp["is_archive"] = is_archive;
    if (is_archive == 0) {
      archieveDataTemp["reportId"] = reportsData?.liveFault?.[0]?.id;
      archieveDataTemp.selectedReportName = reportsData.liveFault?.[0]?.name
    } else {
      archieveDataTemp["reportId"] = reportsData?.archiveFaults?.[0]?.id;
      archieveDataTemp.selectedReportName = reportsData.archiveFaults?.[0]?.name
    }
    getSideBarArcheiveData(archieveDataTemp);
    setArchieveData(archieveDataTemp);
  };

  useEffect(() => {
    let archieveDataTemp = cloneDeep(archieveData);
    archieveDataTemp["is_archive"] = archieveDataObj.is_archive;
    setArchieveData(archieveDataTemp);
  }, [archieveDataObj.is_archive])

  return (
    <div className="leftNavStn">
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded={archieveData.is_archive == 0 ? "true" : "false"}
              aria-controls="collapseOne"
              onClick={() => archriveChangeHandler(0)}
            >
             {selectedTab.tab == "userCS" ? "Live Suggestions" :"Live Faults" }
            </button>
          </h2>
          <div
            id="collapseOne"
            className={archieveData.is_archive == 0 ? "accordion-collapse collapse fault-filters show" : "accordion-collapse collapse fault-filters"}
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <button
                className="fault-btn"
                onClick={() => addReportHandler("live")}
              >
                <i className="zmdi zmdi-file-text zmdi-hc-fw"></i>Add Reports
              </button>
              <div className="filters-list">
                <SideBarFilters
                  selectedFilter={selectedFilter}
                  filtersList={reportsData && reportsData.liveFault}
                  onFiltersHander={onFiltersHander}
                  archieveDataObj={archieveDataObj}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded={archieveData.is_archive == 1 ? "true" : "false"}
              aria-controls="collapseTwo"
              onClick={() => archriveChangeHandler(1)}
            >
              Archives
            </button>
          </h2>
          <div
            id="collapseTwo"
            className={archieveData.is_archive == 1 ? "accordion-collapse collapse fault-filters show" : "accordion-collapse collapse fault-filters"}
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <button
                className="fault-btn"
                onClick={() => addReportHandler("archive")}
              >
                <i className="zmdi zmdi-file-text zmdi-hc-fw"></i>Add Reports
              </button>
              <div className="filters-list">
                <SideBarFilters
                  selectedFilter={selectedFilter}
                  filtersList={reportsData && reportsData.archiveFaults}
                  onFiltersHander={onFiltersHander}
                  archieveDataObj={archieveDataObj}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SideBarFilters = ({
  selectedFilter = {},
  filtersList = [],
  onFiltersHander,
  archieveDataObj
}) => {
  return (
    <ul>
      {filtersList.map((filter, idx) => (
        <li
          className={archieveDataObj && archieveDataObj.reportId === filter.id ? "active" : ""}
          key={idx}
          onClick={() => onFiltersHander(filter)}
        >
          {filter.name}
          <span>
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
          </span>
        </li>
      ))}
    </ul>
  );
};
